const id = {
  announcementQiscusEyebrow: "Pengumuman Penting",
  announcementQiscusTitle: "Koala+ Kini Resmi Menjadi Bagian dari Qiscus",
  announcementQiscusDeadlineLabel:
    "Migrasi ke Qiscus paling lambat / Migration to Qiscus no later than",
  announcementQiscusRemindLater: "Ingatkan Saya Nanti",
  announcementQiscusContactButton:
    "Balas email untuk berdiskusi dengan Konsultan Bisnis",
  announcementQiscusMailSubject: "Diskusi dengan Konsultan Bisnis Qiscus",
  announcementQiscusManualGuide:
    "Jika aplikasi email tidak terbuka, kirim email secara manual ke alamat berikut:",
  announcementQiscusCopyEmail: "Salin alamat",
  announcementQiscusEmailCopied: "Tersalin",
  announcementQiscusSubjectLabel: "Subjek yang disarankan:",
};
const en = {
  announcementQiscusEyebrow: "Important Announcement",
  announcementQiscusTitle: "Koala+ Is Now Officially Part of Qiscus",
  announcementQiscusDeadlineLabel:
    "Migration to Qiscus no later than / Migrasi ke Qiscus paling lambat",
  announcementQiscusRemindLater: "Remind Me Later",
  announcementQiscusContactButton:
    "Reply by email to talk with a Business Consultant",
  announcementQiscusMailSubject: "Discussion with a Qiscus Business Consultant",
  announcementQiscusManualGuide:
    "If your email app does not open, send an email manually to the address below:",
  announcementQiscusCopyEmail: "Copy address",
  announcementQiscusEmailCopied: "Copied",
  announcementQiscusSubjectLabel: "Suggested subject:",
};

export default { id, en };
